<!-- footer is full-page on all screens -->
<div class="footer">
  <div>
    <a href="https://forms.office.com/r/BLhdJw473f"
      >Create Support Ticket</a
    >
    | Information Services Desk | 866-275-5335 | Hours: M-F 8am - 7pm EST |
    <a target="_blank" href="https://www.turnerconstruction.com/privacy"
      >Privacy Policy</a
    >
  </div>
  <div>Copyright &copy; {{year}} The Turner Corporation. All Rights Reserved.</div>
</div>
